var map = {
	"./accordions.js": "./resources/assets/scripts/client/accordions.js",
	"./auto-renewal-toggle.js": "./resources/assets/scripts/client/auto-renewal-toggle.js",
	"./checkout-auto-renewal-toggle.js": "./resources/assets/scripts/client/checkout-auto-renewal-toggle.js",
	"./checkout-form.js": "./resources/assets/scripts/client/checkout-form.js",
	"./checkout-pricing.js": "./resources/assets/scripts/client/checkout-pricing.js",
	"./dropdown.js": "./resources/assets/scripts/client/dropdown.js",
	"./event-calendar.js": "./resources/assets/scripts/client/event-calendar.js",
	"./favourite-content-resource.js": "./resources/assets/scripts/client/favourite-content-resource.js",
	"./formdata-polyfill.js": "./resources/assets/scripts/client/formdata-polyfill.js",
	"./forms.js": "./resources/assets/scripts/client/forms.js",
	"./light-gallery.js": "./resources/assets/scripts/client/light-gallery.js",
	"./main.js": "./resources/assets/scripts/client/main.js",
	"./member-application-review.js": "./resources/assets/scripts/client/member-application-review.js",
	"./members-directory.js": "./resources/assets/scripts/client/members-directory.js",
	"./modal.js": "./resources/assets/scripts/client/modal.js",
	"./oup-member-access.js": "./resources/assets/scripts/client/oup-member-access.js",
	"./rate-content-resource.js": "./resources/assets/scripts/client/rate-content-resource.js",
	"./social-icons.js": "./resources/assets/scripts/client/social-icons.js",
	"./spotify-embed.js": "./resources/assets/scripts/client/spotify-embed.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./resources/assets/scripts/client sync recursive \\.js$";